import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Select,
  MenuItem,
  ListItemText,
  FormControl,
  Typography
} from "@mui/material";
import { BUSINESS_TYPES } from "../../json-data/bussiness-terms";

export default function Bank5Modal({
  open,
  onClose,
  onSubmit,
  annualIncome,
  setAnnualIncome,
  natureBusiness,
  setNatureBusiness,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Bank5 Business Details</DialogTitle>

      <DialogContent className="flex flex-col gap-3">

        {/* Annual Income Label */}
        <Typography fontSize={13} fontWeight={600}>
          Annual Income <span style={{ color: "red" }}>*</span>
        </Typography>

        <TextField
          placeholder="Enter annual income"
          value={annualIncome}
          onChange={(e) => setAnnualIncome(e.target.value.replace(/\D/g, ""))}
          fullWidth
          size="small"
        />

        {/* Nature of Business Label */}
        <Typography fontSize={13} fontWeight={600}>
          Nature of Business <span style={{ color: "red" }}>*</span>
        </Typography>

        <FormControl fullWidth size="small">
          <Select
            value={natureBusiness}
            onChange={(e) => setNatureBusiness(e.target.value)}
            displayEmpty
          >
            <MenuItem value="">
              <em>Select Nature of Business</em>
            </MenuItem>

            {BUSINESS_TYPES.map((b) => (
              <MenuItem key={b.term} value={b.term}>
                <ListItemText
                  primary={b.term}
                  secondary={b.definition}
                  primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }}
                  secondaryTypographyProps={{ fontSize: 11 }}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Continue Button */}
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={!annualIncome || !natureBusiness}
          sx={{ mt: 1 }}
        >
          Continue
        </Button>
      </DialogContent>
    </Dialog>
  );
}
